export default {
  SIGNATURE_INIT: "SIGNATURE_INIT",
  SIGNATURE_IN_PROGRESS: "SIGNATURE_IN_PROGRESS",
  SIGNATURE_RESET: "SIGNATURE_RESET",
  SIGNATURE_COMPLETED: "SIGNATURE_COMPLETED",
  SIGNATURE_ACQUIRED: "SIGNATURE_ACQUIRED",
  SIGNATURE_SUBMITTED: "SIGNATURE_SUBMITTED"
};
